<template>
  <div>
    <slot name="header" />
    <div
      id="layout"
      :class="layoutClass"
    >
      <LazyExtraGuaranteeSidebar
        v-if="!isOnPaymentPage"
      />
      <slot />
      <slot name="content" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ROUTES } from '~~/constants/routes';
import { getSlugForRoute } from '~~/helpers/routes/getPageInformation';
import { isCheckoutDisabled } from '~~/helpers/Checkout/isCheckoutDisabled';

defineOptions({ name: 'BaseLayout' });

useLoadCalls();

const route = useRoute();
const { getAdjustedSlug } = useRouteExtended();
const { isOnPaymentPage, isCheckoutPage } = useIsPage();
const router = useRouter();
const { countryCode } = useLocalization();

const checkoutContainerRoutes = [
  ROUTES.CHECKOUT_ADDRESSES,
  ROUTES.CHECKOUT_PAYMENT,
  ROUTES.THANK_YOU,
];

const layoutClass = computed(() => {

  const checkoutPaths = checkoutContainerRoutes.flatMap((routeKey) => {

    const canonicalSlug = getSlugForRoute(routeKey);
    const localizedSlug = getAdjustedSlug(routeKey);

    return canonicalSlug === localizedSlug
      ? [canonicalSlug]
      : [canonicalSlug, localizedSlug];

  });

  if (checkoutPaths.includes(route.path)) {

    return 'container m-auto';

  } else {

    return 'full-width';

  }

});

onMounted(() => {

  if (isCheckoutPage.value && isCheckoutDisabled(countryCode.value)) {

    router.push('/');

  }

});
</script>
